import { configureStore } from '@reduxjs/toolkit';
import { listenerMiddleware } from './middleware/analyzeReport.listeners';
import reducer from './redux';

const store = configureStore({
  reducer,
  devTools: {
    trace: true,
    traceLimit: 25
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(listenerMiddleware.middleware),
});

export type AppDispatch = typeof store.dispatch;

export default store;